import React from 'react'
// import { usePopperTooltip } from 'react-popper-tooltip'
import 'react-popper-tooltip/dist/styles.css'

const SelectComponent = ({
  title, 
  isDisabled,
  id, 
  name, 
  value, 
  value1, 
  value2, 
  value3, 
  value4, 
  value5, 
  value6, 
  texto1,
  texto2,
  // tooltipText,
  placeHolder,
  onChange}) => {

    // const {
    //   getArrowProps,
    //   getTooltipProps,
    //   setTooltipRef,
    //   setTriggerRef,
    //   visible
    // } = usePopperTooltip()

  return (

    <div className="mb-1"> {/*col-xl-4 col-sm-12 */}
      <label htmlFor={id} className="form-label">{title}</label>
      {/* <i className="fas fa-info-circle ms-2"
      ref={setTriggerRef}></i> */}
      {/* {
        visible && (
          <div
            ref={setTooltipRef}
            {...getTooltipProps({ className: 'tooltip-container' })}
          >
          <div {...getArrowProps({ className: 'tooltip-arrow' })} />
            {tooltipText ? tooltipText : null}
          </div>
        )
      } */}
      <select 
        name={name} 
        id={id}
        value={value}
        onChange={onChange}
        autoComplete="off"
        className="form-select" 
        disabled={isDisabled}
      >
        <option value="" defaultValue>{placeHolder}</option>
        {value1 ? (
          <option value={value1 ? value1 : null}>{texto1 ? texto1 : value1}</option>
        ) : null}
        {value2 ? (
          <option value={value2 ? value2 : null}>{texto2 ? texto2 : value2}</option>
        ) : null}
        {value3 ? (
          <option value={value3 ? value3 : null}>{value3 ? value3: null}</option>
        ) : null}
        {value4 ? (
          <option value={value4 ? value4 : null}>{value4 ? value4 : null}</option>
        ) : null}
        {value5 ? (
          <option value={value5 ? value5 : null}>{value5 ? value5 : null}</option>
        ) : null}
        {value6 ? (
          <option value={value6 ? value6 : null}>{value6 ? value6 : null}</option>
        ) : null}

      </select>
    </div>
  )
}

export default SelectComponent
